import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'unh-dialog-navigation',
  templateUrl: './dialog-navigation.component.html',
  styleUrls: ['./dialog-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogNavigationComponent {
  @Input() rtlButtonEnabled = false;
  @Input() ltrButtonEnabled = false;
  @Output() navButtonClicked = new EventEmitter<'ltr' | 'rtl'>();
}
